<template>
  <el-dialog v-if="appStore.hasSideEffectLoading" :model-value="appStore.hasSideEffectLoading" width="30%"
    :close-on-click-modal="false" :before-close="handleDialogClose" :show-close="false">
    <div class="loading-content">
      <el-icon class="is-loading" :size="32">
        <Loading />
      </el-icon>
      <p>Loading, please wait...</p>
    </div>
  </el-dialog>
</template>

<script setup>
import { Loading } from '@element-plus/icons-vue'
import { useAppStore } from '@/stores/app'

const appStore = useAppStore()

function handleDialogClose(done) {
  done()
}
</script>

<style>
.loading-content {
  text-align: center;
}

.loading-content .el-icon {
  margin-bottom: 16px;
}

.el-dialog__body {
  font-size: 14px;
}
</style>
